const ReallocationSubMenuIcon = () => {
  return (
    <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="27" cy="27" r="27" fill="#E6F1FF" />
      <path
        d="M26.1604 34.2184C26.1453 34.0379 26.1303 33.8573 26.1303 33.6693C26.1303 30.7205 28.5224 28.3359 31.4636 28.3359C33.1185 28.3359 34.6004 29.0882 35.5783 30.2767"
        stroke="#0276FE"
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M36.7824 33.1992C36.7975 33.3572 36.805 33.5076 36.805 33.6656C36.805 36.6144 34.4129 38.9989 31.4717 38.9989C29.7114 38.9989 28.1468 38.1489 27.1764 36.8325"
        stroke="#0276FE"
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M34.7438 34.8689L36.5953 33.3523C36.6944 33.2711 36.8424 33.2954 36.9103 33.404L38.2415 35.5311"
        stroke="#0276FE"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M28.2667 32.4956L26.3474 34.0587C26.2482 34.1395 26.1006 34.1151 26.0328 34.0066L24.7012 31.8789"
        stroke="#0276FE"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M31.3286 15H15.2529C15.1106 15 15 15.1106 15 15.2529V34.4742"
        stroke="#0276FE"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M24.2469 38.222H18.8409C18.6986 38.222 18.588 38.1113 18.588 37.9691V18.8584C18.588 18.7161 18.6986 18.6055 18.8409 18.6055H34.1104C34.2527 18.6055 34.3634 18.7161 34.3634 18.8584V25.6815"
        stroke="#0276FE"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </svg>
  );
};
export default ReallocationSubMenuIcon;
